<template>
  <div class="tw:flex tw:flex-col tw:gap-1.5">
    <h2 class="tw:reg-title">
      {{ title }}
    </h2>

    <!-- slot as well as prop so steps can emphasise the registrant's own address -->
    <p v-if="lede || $slots.default" class="tw:reg-lede">
      <slot>{{ lede }}</slot>
    </p>
  </div>
</template>

<script setup lang="ts">
/** The title and lede every wizard step opens with; one `h2` per pane. */
interface Props {
  title: string;
  lede?: string;
}

defineProps<Props>();
</script>
